export default function RcmpArrowDown(props) {
    return (
      <svg
        width="11"
        height="7"
        viewBox="0 0 11 7"
        fill={props.color || "#415364"}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M10.6508 1.35407L5.91005 5.8968C5.79585 6.00715 5.6477 6.06194 5.50032 6.06194C5.35293 6.06194 5.20481 6.00715 5.09061 5.8968L0.349908 1.35407C0.113018 1.1281 0.10529 0.753085 0.332155 0.516985C0.557464 0.27933 0.934008 0.271602 1.16934 0.499232L5.50032 4.64855L9.83132 0.499232C10.0659 0.271602 10.4432 0.27933 10.6685 0.516985C10.8953 0.753085 10.8876 1.1281 10.6508 1.35407Z"
          
        />
      </svg>
    )
}
